import type { ReactNode } from 'react'
import { useAuth } from '../context/AuthContext'
import { LoginPage } from '../features/auth/LoginPage'

export function RequireAuth({ children }: { children: ReactNode }) {
  const { session } = useAuth()
  if (!session) return <LoginPage />
  return <>{children}</>
}

export function RequireAdmin({ children }: { children: ReactNode }) {
  const { isAdmin } = useAuth()
  if (!isAdmin) return <p className="text-muted">No tienes acceso a esta sección.</p>
  return <>{children}</>
}
